module.exports = __webpack_public_path__ + "static/media/reimbursement-approval-flow.8ec44e0c.svg";